<div class="menu-container p-2 pt-3">
  <p-panelMenu
    [model]="items"
    [style]="{ width: '270px' }"
    [multiple]="true"
  ></p-panelMenu>
  <img src="./assets/icons/ellada2.png" alt="Ellada Logo" class="side-menu-footer" />
</div>
